import { useMemo } from 'react'
import { Button } from '../../../../../../components/Button'
import { Icon } from '../../../../../../components/Icon'
import { Stack } from '../../../../../../components/Stack'
import { Text } from '../../../../../../components/Text'
import { RoundContainer, ToastRoot } from './AccountBanner.styles'

const toastVariantToIconMap: any = {
  success: 'check-fill',
  error: 'close-line',
  info: 'information-line',
}

export const AccountBannerRoot = (props: any) => {
  const { clickHandler, children, bannerTone } = props
  const iconName = useMemo(() => toastVariantToIconMap['info'], [])

  return (
    <ToastRoot tone={bannerTone} type="noAnimation">
      <Stack gap="2" alignItems="flex-start">
        <RoundContainer>
          <Icon name={iconName} color={'tertiary-600'} />
        </RoundContainer>

        <Stack direction="column" css={{ flex: 1 }}>
          {children}
        </Stack>
      </Stack>
    </ToastRoot>
  )
}

AccountBannerRoot.displayName = 'AccountBannerRoot'
